import { render, staticRenderFns } from "./ShopDailyManage.vue?vue&type=template&id=767601b6&scoped=true"
import script from "./ShopDailyManage.vue?vue&type=script&lang=js"
export * from "./ShopDailyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767601b6",
  null
  
)

export default component.exports